import * as actionTypes from './actionTypes';
import axios from '../../utilities/interceptor';
import { getMessage } from '../../utilities/getMessage';

export const createMember=(request)=>async dispatch=>{
    dispatch({
        type:actionTypes.CREATE_MEMBER_START
    })
    const options={
        url:`/auth/member/signup`,
        method:'POST',
        data:request
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.CREATE_MEMBER_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.CREATE_MEMBER_FAIL,
                payload:getMessage(error)
            }))
}